export enum UserRole {
    Admin = 4,
    Super = 5,
    FieldManagerFull = 6,
    FieldManagerBase = 7,
    Purchasing = 8,
    PurchasingAppWide = 9,
    Accounting = 10,
    AccountingAppWide = 11,
    Office = 12,    
    Sales = 15,
    PurchaseOrdersAdmin = 16,
    CustomerCareManager = 20,
    SuperAdmin = 21,
    CcmFmHybrid = 23
}
